// GENERADO por tools/ifc-qto/qto-del-estandar.py desde las plantillas oficiales de buildingSMART
// (Qto_*BaseQuantities, IFC4X3 > IFC4 > IFC2X3) que trae IfcOpenShell. NO editar a mano.
//
// Magnitudes (largo, área, volumen) que el ESTÁNDAR declara para medir cada clase. Lo usa
// `medidaQueManda` (medicionIfc.ts): si una clase declara una sola, esa es la que manda.
export const MAGNITUDES_QTO_DEL_ESTANDAR: Readonly<Record<string, readonly ('area' | 'longitud' | 'volumen')[]>> = {
  IfcActuator: [],
  IfcAirTerminal: ['area', 'longitud'],
  IfcAirTerminalBox: [],
  IfcAirToAirHeatRecovery: [],
  IfcAlarm: [],
  IfcAudioVisualAppliance: [],
  IfcBeam: ['area', 'longitud', 'volumen'],
  IfcBoiler: ['area'],
  IfcBuilding: ['area', 'longitud', 'volumen'],
  IfcBuildingStorey: ['area', 'longitud', 'volumen'],
  IfcBurner: [],
  IfcCableCarrierFitting: [],
  IfcCableCarrierSegment: ['area', 'longitud'],
  IfcCableFitting: [],
  IfcCableSegment: ['area', 'longitud'],
  IfcChiller: [],
  IfcChimney: ['longitud'],
  IfcCoil: [],
  IfcColumn: ['area', 'longitud', 'volumen'],
  IfcCommunicationsAppliance: [],
  IfcCompressor: [],
  IfcCondenser: [],
  IfcConstructionEquipmentResource: [],
  IfcConstructionMaterialResource: ['volumen'],
  IfcController: [],
  IfcCooledBeam: [],
  IfcCoolingTower: [],
  IfcCourse: ['longitud', 'volumen'],
  IfcCovering: ['area', 'longitud'],
  IfcDamper: [],
  IfcDistributionChamberElement: ['area', 'longitud', 'volumen'],
  IfcDoor: ['area', 'longitud'],
  IfcDuctFitting: ['area', 'longitud'],
  IfcDuctSegment: ['area', 'longitud'],
  IfcDuctSilencer: [],
  IfcEarthworksCut: ['longitud', 'volumen'],
  IfcEarthworksFill: ['longitud', 'volumen'],
  IfcElectricAppliance: [],
  IfcElectricDistributionBoard: [],
  IfcElectricFlowStorageDevice: [],
  IfcElectricGenerator: [],
  IfcElectricMotor: [],
  IfcElectricTimeControl: [],
  IfcEvaporativeCooler: [],
  IfcEvaporator: [],
  IfcFacilityPart: ['area', 'longitud', 'volumen'],
  IfcFan: [],
  IfcFilter: [],
  IfcFireSuppressionTerminal: [],
  IfcFlowInstrument: [],
  IfcFlowMeter: [],
  IfcFooting: ['area', 'longitud', 'volumen'],
  IfcGeotechnicalStratum: ['area', 'longitud'],
  IfcHeatExchanger: [],
  IfcHumidifier: [],
  IfcImpactProtectionDevice: [],
  IfcInterceptor: [],
  IfcJunctionBox: ['longitud'],
  IfcKerb: ['longitud', 'volumen'],
  IfcLaborResource: [],
  IfcLamp: [],
  IfcLightFixture: [],
  IfcMarineFacility: ['area', 'longitud', 'volumen'],
  IfcMember: ['area', 'longitud', 'volumen'],
  IfcMotorConnection: [],
  IfcOpeningElement: ['area', 'longitud', 'volumen'],
  IfcOutlet: [],
  IfcPavement: ['area', 'longitud', 'volumen'],
  IfcPile: ['area', 'longitud', 'volumen'],
  IfcPipeFitting: ['area', 'longitud'],
  IfcPipeSegment: ['area', 'longitud'],
  IfcPlate: ['area', 'longitud', 'volumen'],
  IfcProjectionElement: ['area', 'volumen'],
  IfcProtectiveDevice: [],
  IfcProtectiveDeviceTrippingUnit: [],
  IfcPump: [],
  IfcRail: ['longitud', 'volumen'],
  IfcRailing: ['longitud'],
  IfcRampFlight: ['area', 'longitud', 'volumen'],
  IfcReinforcedSoil: ['area', 'longitud', 'volumen'],
  IfcReinforcingElement: ['longitud'],
  IfcRoof: ['area'],
  IfcSanitaryTerminal: [],
  IfcSensor: [],
  IfcSign: ['longitud'],
  IfcSignal: [],
  IfcSite: ['area', 'longitud'],
  IfcSlab: ['area', 'longitud', 'volumen'],
  IfcSolarDevice: ['area'],
  IfcSpace: ['area', 'longitud', 'volumen'],
  IfcSpaceHeater: ['longitud'],
  IfcSpatialZone: ['longitud'],
  IfcStackTerminal: [],
  IfcStairFlight: ['longitud', 'volumen'],
  IfcSurfaceFeature: ['area', 'longitud'],
  IfcSwitchingDevice: [],
  IfcTank: ['area'],
  IfcTrackElement: ['longitud'],
  IfcTransformer: [],
  IfcTubeBundle: [],
  IfcUnitaryControlElement: [],
  IfcUnitaryEquipment: [],
  IfcValve: [],
  IfcVehicle: ['longitud'],
  IfcVibrationIsolator: [],
  IfcWall: ['area', 'longitud', 'volumen'],
  IfcWasteTerminal: [],
  IfcWindow: ['area', 'longitud'],
};
